import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TetonPatient } from '../model/teton-patient';
import { HttpHelperService } from './httphelper.service';
import { Observable } from 'rxjs';

const API_URL = environment.apiUrl;

@Injectable()
export class TetonService {
	constructor(private http: HttpClient, private httpHelperService: HttpHelperService) {
	}

	getPatients(): Observable<HttpResponse<TetonPatient[]>> {
		return this.http.get<TetonPatient[]>(`${API_URL}teton/patients/all`, this.httpHelperService.getHttpOptions());
	}

	importDepartments(): Observable<HttpResponse<any>> {
		return this.http.post<any>(`${API_URL}teton/departments/import-all`, {}, this.httpHelperService.getHttpOptions());
	}

	validateTetonToken(token: string, carehomeId: string = null): Observable<HttpResponse<{ isValid: boolean }>> {
		return this.http.post<{ isValid: boolean }>(`${API_URL}teton/validate-token${carehomeId ? `?carehomeId=${carehomeId}` : ''}`, JSON.stringify(token), this.httpHelperService.getHttpOptions());
	}
}
